module.exports = __webpack_public_path__ + "static/media/Clown.a2b5e8bf.jpg";